import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  BumpedItemStatsDto,
  ItemBumpStatsResponse,
  ItemPerformanceDto,
  ItemPerformanceModel,
  ItemPerformanceResponse,
} from '../types/item-performance'

export const transformItemPerformance = (
  dto: ItemPerformanceDto | BumpedItemStatsDto,
): ItemPerformanceModel => ({
  impressions: dto.impressions,
  favorites: dto.favorites,
  views: dto.views,
  conversations: dto.conversations,
  humanizedHoursLeft: dto.humanized_hours_left,
  promotionEndedDaysAgo: dto.promotion_ended_days_ago,
  recentlyPromoted: dto.recently_promoted,
  impressionDifference: dto.impression_difference,
  chartData: dto.chart_data,
})

export const transformItemPerformanceResponse = (response: Response<ItemPerformanceResponse>) => {
  return response.item_performance ? transformItemPerformance(response.item_performance) : null
}

export const transformItemBumpStatsResponse = (response: Response<ItemBumpStatsResponse>) => {
  return response.bumped_item_stats ? transformItemPerformance(response.bumped_item_stats) : null
}
